import { useEffect, useState } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isPwaInstalled } from './pwa-install';
import { browserChromeBottom, tabBarPlacement } from './tab-bar-inset';

function readChromeBottom() {
  if (typeof window === 'undefined') {
    return 0;
  }
  const viewport = window.visualViewport;
  if (!viewport) {
    return 0;
  }
  return browserChromeBottom(window.innerHeight, viewport.height, viewport.offsetTop);
}

function isMobileBrowser() {
  if (typeof navigator === 'undefined' || isPwaInstalled()) {
    return false;
  }
  const ua = navigator.userAgent;
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  return isIOS || /Android/.test(ua);
}

export function useTabBarPlacement() {
  const insets = useSafeAreaInsets();
  const [chromeBottom, setChromeBottom] = useState(readChromeBottom);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const update = () => setChromeBottom(readChromeBottom());
    update();
    window.visualViewport?.addEventListener('resize', update);
    window.visualViewport?.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => {
      window.visualViewport?.removeEventListener('resize', update);
      window.visualViewport?.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return tabBarPlacement({
    safeAreaBottom: insets.bottom,
    chromeBottom,
    standalone: isPwaInstalled(),
    mobileBrowser: isMobileBrowser(),
  });
}
